import {register} from '@shopify/theme-sections';
import {ProductRecentlyViewed} from './product-recently-viewed';

const KEY = 'product-recently-viewed';
const SELECTOR = `.${KEY}`;

register(KEY, {
  async onLoad() {
    const section = document.querySelector(SELECTOR) as HTMLElement;

    if (section) {
      new ProductRecentlyViewed(section);
    }
  },
});
